import type {
  ReflexDefinition,
  SaveReflexInput,
} from "../../../services/admin/reflexes.service";

export interface ReflexRuleFormValue {
  targetPanelDefinitionId: string;
  icdCodeIds: string[];
}

export interface ReflexFormValues {
  name: string;
  description: string;
  startingPanelDefinitionId: string;
  rules: ReflexRuleFormValue[];
}

export const EMPTY_REFLEX_RULE: ReflexRuleFormValue = {
  targetPanelDefinitionId: "",
  icdCodeIds: [],
};

export function getReflexFormValues(
  reflex?: ReflexDefinition
): ReflexFormValues {
  return {
    name: reflex?.name ?? "",
    description: reflex?.description ?? "",
    startingPanelDefinitionId: reflex?.startingPanelDefinitionId ?? "",
    rules: reflex?.rules.map((rule) => ({
      targetPanelDefinitionId: rule.targetPanelDefinitionId,
      icdCodeIds: rule.icdCodes.map((code) => code.id),
    })) ?? [{ ...EMPTY_REFLEX_RULE }],
  };
}

export function toSaveReflexInput(values: ReflexFormValues): SaveReflexInput {
  return {
    name: values.name.trim(),
    description: values.description.trim() || undefined,
    startingPanelDefinitionId: values.startingPanelDefinitionId,
    rules: values.rules.map((rule) => ({
      targetPanelDefinitionId: rule.targetPanelDefinitionId,
      icdCodeIds: Array.from(new Set(rule.icdCodeIds)),
    })),
  };
}
